"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const Phase_1 = require("@/common/Phase");
exports.default = (0, vue_1.defineComponent)({
    name: 'GameOverview',
    data() {
        return {};
    },
    props: {
        status: {
            type: String,
            required: true,
        },
        game: {
            type: Object,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
    },
    computed: {
        statusClass() {
            switch (this.status) {
                case 'loading':
                    return 'status-loading';
                case 'error':
                    return 'status-error';
                case 'done':
                    if (this.isRunning) {
                        return 'status-running';
                    }
                    else {
                        return 'status-finished';
                    }
                default:
                    return '';
            }
        },
        isRunning() {
            return this.game?.phase !== Phase_1.Phase.END;
        },
    },
});
